import { createRoutine, promisifyRoutine } from 'redux-saga-routines'

export const updateProfile = createRoutine('profile/UPDATE_PROFILE')
export const updateProfilePromiseCreator = promisifyRoutine(updateProfile)
export const changePassword = createRoutine('profile/CHANGE_PASSWORD')
export const changePasswordPromiseCreator = promisifyRoutine(changePassword)
